import { getConnectionEnvironment } from "./environment";

const getServerUrl = (): string => {
  const environment = getConnectionEnvironment();

  const serverUrls = {
    Production: "https://landlord.cloudastera.com",
    UAT: "https://qa-landlord.cloudastera.com",
    PlayTest: "http://132.196.241.118",
    Local: "https://localhost:9092",
    Staging: "https://staging-landlord.cloudastera.com",
    OnPremiseUSCluster1: "https://release1-us-landlord.cloudastera.com",
    OnPremiseUSCluster2: "https://release2-us-landlord.cloudastera.com",
    OnPremiseUSCluster3: "https://release3-us-landlord.cloudastera.com",
    OnPremisePKCluster1: "https://release1-pk-landlord.cloudastera.com",
    OnPremisePKCluster2: "https://release2-pk-landlord.cloudastera.com",
    OnPremisePKCluster3: "https://release3-pk-landlord.cloudastera.com",
    DocspireUAT: "https://qa-landlord.docspire.ai",
    Docspire: "https://landlord.docspire.ai",
  };

  return serverUrls[environment];
};

export default getServerUrl;